
const digest = '9e7aea997703f8a6115206dcd5212c10ddb35ccd44b06329a55a6ec2d9fa79c4';
const classes = {"wrapper":"_wrapper_1pe1u_1","content":"_content_1pe1u_5"};
const css = `._wrapper_1pe1u_1 {
  height: 100%;
  background: #ffffff;
}
._wrapper_1pe1u_1 ._content_1pe1u_5 {
  padding: 12px;
  border: 1px solid #e2e5ed;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  